// extracted by mini-css-extract-plugin
export default {"globalPreviewPromotionScale":"2.4","md-menu-content":"main-visitant_md-menu-content_UaZqZ","box":"main-visitant_box_Wh8FZ","container":"main-visitant_container_NFkTM"};